import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FuseUploadComponent } from './upload.component';
import { MatButtonModule, MatProgressBarModule, MatListModule, MatDialogModule, MatIconModule, MatToolbarModule } from '@angular/material';
import { DialogComponent } from './dialog/dialog.component';
import { FuseUploadService } from './upload.service';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [
        FuseUploadComponent,
        DialogComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatProgressBarModule,
        MatListModule,
        MatDialogModule,
        MatIconModule,
        MatToolbarModule,
        TranslateModule
    ],
    exports: [
        FuseUploadComponent
    ],
    entryComponents: [
        DialogComponent
    ],
    providers: [
        FuseUploadService
    ]
})
export class FuseUploadModule {
}
